<template>
  <div class="page-container">
    <div class="content">
      <h1>{{ error.status }}</h1>

      <h2 v-if="error.status == 400">{{ renderMessage('Something went wrong. Please try again later.') }}</h2>
      <h2 v-if="error.status == 401">{{ renderMessage('We could not authorise this request.') }}</h2>
      <h2 v-if="error.status == 404">{{ renderMessage('We could not find this resource.') }}</h2>
      <h2 v-if="error.status == 500">{{ renderMessage('Something appears to have happen to our servers. Please try again
        later.') }}</h2>

      <uiv-btn class="btn btn-primary" @click="$router.go(-1)" v-if="error.status != 500 && error.status != 404">Try
        Again</uiv-btn>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'ErrorPage',
  computed: {
    ...mapState({
      error: ({ error }) => error
    })
  },
  async mounted() {
    this.$store.dispatch('tracing/addAction', { name: 'Page', value: `${this.error.status} Error Page` });
    await this.$store.dispatch('tracing/saveActions');
  },
  methods: {
    renderMessage(genericMessage) {
      if (this.error.message) {
        return this.error.message;
      }

      return genericMessage;
    }
  }
};
</script>

<style lang="scss" scoped>
.page-container {
  position: fixed;
  border: 20px solid $brand-colour-primary;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: #fff;
  min-height: 700px;
  overflow-y: auto;
  z-index: 10;

  >.content {
    max-width: 600px;
    width: 100%;
    position: absolute;
    top: 50%;
    right: 0;
    left: 0;
    bottom: 0;
    margin: auto;
    transform: translate(0, -50%);

    h1 {
      margin: 0;
      font-size: 200px;
      color: #dfdfdf;

      @media(max-width: 991px) {
        font-size: 80px;
      }
    }

    h2 {
      font-weight: 300;
      color: #373737;

      @media(max-width: 991px) {
        font-size: 20px;
      }
    }

    @media(max-width: 991px) {
      padding: 0 20px;
    }
  }
}
</style>
